const messages = {
    'v.input.required': 'The input value cannot be empty',
    'v.input.so':'The correct SO value is 10 digits/6 digits',
    'v.email.required': 'Email cannot be empty',
    'v.select.required': 'The selection value cannot be empty',
    'v.input.max2': 'Text cannot exceed 2 characters',
    'v.input.max9': 'Text cannot exceed 9 characters',
    'v.input.max10': 'Text cannot exceed 10 characters',
    'v.input.max16': 'Text cannot exceed 16 characters',
    'v.input.max17': 'Text cannot exceed 17 characters',
    'v.input.max18': 'Text cannot exceed 18 characters',
    'v.input.max20': 'Text cannot exceed 20 characters',
    'v.input.max25': 'Text cannot exceed 25 characters',
    'v.input.max35': 'Text cannot exceed 35 characters',
    'v.input.max40': 'Text cannot exceed 40 characters',
    'v.input.max50': 'Text cannot exceed 50 characters',
    'v.input.max70': 'Text cannot exceed 70 characters',
    'v.input.max75': 'Text cannot exceed 75 characters',
    'v.input.max100': 'Text cannot exceed 100 characters',
    'v.input.max200': 'Text cannot exceed 200 characters',
    'v.input.max250': 'Text cannot exceed 250 characters',
    'v.input.max500': 'Text cannot exceed 500 characters',
    'v.input.max2000': 'Text cannot exceed 2000 characters',
    'v.phone.formaterror': 'Phone format error',    
    'v.remark.isnotnull': 'Remarks cannot be empty',
    'v.region.parentid.required': 'Please select the parent region!',
    'v.expressorder.carrier.required': 'Please select a carrier!',
    'v.expressorder.batchimport.nodatas': 'Please upload the data that needs to be imported!',
    'v.expressorder.batchimport.datavaliderror': 'There is an issue with the uploaded data, please correct it!',
    'v.mobile.expressorder.cargoitem.required': 'Please fill in the item details!',
    'v.mobile.expressorder.exportdeclarationitem.required': 'Please fill in the item details!',
    'v.mobile.select.required': 'Please select',
    'v.mobile.input.required': 'Required',
    'v.mobile.expressorder.shipperaddress.required': "Please select the sender's address",
    'v.mobile.expressorder.receiveraddress.required': "Please select recipient address",
    'v.mobile.expressorder.cargo.required': 'Please fill in the cargo details!',
    'v.mobile.expressorder.shipper.email.required': "The shipper's email cannot be empty!",
    'v.mobile.expressorder.exportdeclaration.required': 'Please fill in the export declaration details!',
    'v.process.approvalremark.required': 'Please enter the processing reason in the remarks!'
  };
  export default messages;
  